import {
  getRequestV2,
  postRequestV2,
  patchRequestV2,
  deleteRequestV2,
} from '../../methods';

// Initiatives
const createInitiativeV2 = payload => postRequestV2(`initiatives`, payload);
const getInitiativeById = initiativeId =>
  getRequestV2(`initiatives/${initiativeId}`);
const updateStandaloneInitiative = (initiativeId, payload) =>
  patchRequestV2(`initiatives/${initiativeId}`, payload);
const updateInitiativeStatus = (initiativeId, payload) =>
  patchRequestV2(`initiatives/${initiativeId}/update_status`, payload);
const deleteInitiativeById = initiativeId =>
  deleteRequestV2(`initiatives/${initiativeId}`);

const getInitiativeTypes = () => getRequestV2('initiative_types');
const createInitiativeType = payload =>
  postRequestV2('initiative_types', payload);
const updateInitiativeType = (initiativeTypeId, payload) =>
  patchRequestV2(`initiative_types/${initiativeTypeId}`, payload);
const archiveInitiativeType = (initiativeTypeId, payload) =>
  patchRequestV2(`initiative_types/${initiativeTypeId}/archive`, payload);
const unarchiveInitiativeType = (initiativeTypeId, payload) =>
  patchRequestV2(`initiative_types/${initiativeTypeId}/unarchive`, payload);

const initiatives = {
  updateStandaloneInitiative,
  deleteInitiativeById,
  getInitiativeById,
  updateInitiativeStatus,
  createInitiativeV2,
  getInitiativeTypes,
  createInitiativeType,
  updateInitiativeType,
  archiveInitiativeType,
  unarchiveInitiativeType,
};

export default initiatives;
